import React from "react";
import { type Mode, type Theme } from "~/features/ui/get-theme-style";
type ContextProps = {
  theme: Theme;
  mode: Mode;
  diff: number[];
  activeProductsIds: string[];
  toggleProductColumn: (pid: string) => void;
  showDiff: boolean;
  onToggleDiff: (v: boolean) => void;
  hoveredRow: number;
  onHoveredRow: (v: number) => void;
};
export const HardwareComparisonContext = React.createContext<ContextProps | undefined>(undefined);
export function useHardwareComparison() {
  const context = React.useContext(HardwareComparisonContext);
  if (!context) {
    throw new Error("useHardwareComparison must be used within a HardwareComparisonProvider");
  }
  return context;
}